import { lazy, Suspense, useEffect, useState } from 'react';
import {
  getArticleReaderState, registerArticleReaderHost, subscribeArticleReader,
} from '@/lib/articleReader';

// Сама панель — отдельным чанком: в главный бандл идёт только этот хозяин,
// панель грузится по первому клику на заголовок-ссылку.
const ArticleReaderPanel = lazy(() => import('./ArticleReaderPanel'));

/** Один на приложение (App.js): показывает читалку статей поверх страницы. */
export default function ArticleReaderHost() {
  const [state, setState] = useState(getArticleReaderState);
  useEffect(() => {
    const unregister = registerArticleReaderHost();
    const unsubscribe = subscribeArticleReader(setState);
    return () => { unsubscribe(); unregister(); };
  }, []);
  if (!state.link) return null;
  return (
    <Suspense fallback={null}>
      <ArticleReaderPanel link={state.link} label={state.label} />
    </Suspense>
  );
}
